import React, { Component, Fragment } from 'react';
import Wrapper from './../../../common/component/Wrapper';
import * as Func from '../../../../../helpers/functions';
import { Link } from 'react-router-dom';
import { DATE_TIME_FORMAT, PATHS, TRANSLATE_LANGUAGE } from '../../../../../constants/Define';
import { FilterDropdown, ListComponent, SelectComponent } from '../../../common/component/Index';
import Modal from '../../../common/component/Modal';
import Ripple from '../../../common/component/Ripple';
import Dropdown from '../../../common/component/Dropdown';
import { FlagIcons } from '../../../common/component/TranslateButton';

import GroupCategory from '../../../../../models/GroupCategory';
import { Icon, Menu } from 'antd';
import { isEqual, toArray } from 'lodash';
import './GroupCategoryList.less';
import { parseFlatArrayToTreeData } from '../../../../../utils/commonUtils';

const defaultState = {

};

const ListCols = ['name', 'order', 'createdDate', 'translations'];
const ModelFields = Object.getOwnPropertyNames(new GroupCategory());

export default class GroupCategoryList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            titleItemTable: Func.getTitleTable(ListCols, ['action'], []),
            modelItem: ModelFields,
            componentTable: {
                name: {
                    sorter: (i, k) => i.name.length - k.length,
                    key: 'name',
                    width: 250,
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                        >
                        </FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                },
                order: {
                    align: 'right',
                    sorter: (i, k) => i.order.length - k.length,
                    key: 'order',
                },
                // parentName: {
                //     key: 'parentId',
                //     filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
                //         <SelectComponent
                //             optionFilterProp="children"
                //             className={`hms-form-control select-filter`}
                //             value={selectedKeys[0]}
                //             showSearch
                //             hmsData={this.props.parents}
                //             allowClear
                //             onChange={e => {
                //                 setSelectedKeys(Func.getValueForm(e).value ? [Func.getValueForm(e).value] : []);
                //                 confirm();
                //             }}
                //         />
                //     ),
                //     filterIcon: filtered => (
                //         <Icon type="filter" style={{ color: filtered ? '#1890ff' : undefined }} />
                //     ),
                // },
                createdDate: {
                    render: (text, record) => record.createdDate && record.createdDate.format(DATE_TIME_FORMAT.SHORT_DATE),
                    sorter: (i, k) => i.createdDate.length - k.length,
                    key: 'createdDate',
                },
                translations: {
                    key: 'languageCode',
                    filters: toArray(TRANSLATE_LANGUAGE).map(lang => ({
                        value: lang.code, text: this.props.t(`translate.languages.${lang.id}`)
                    })),
                    filterMultiple: false,
                    render: (text, record) => <FlagIcons languages={record.translations} />,
                },
                action: {
                    width: 100,
                    align: 'center',
                    key: 'action',
                    render: (text, record, index) => this.renderEditComponent(record, index),
                }
            },
            expendedRows: [],
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.categories && prevProps.categories !== this.props.categories) {
            this.setState({ expendedRows: this.props.categories.map(item => item.id) })
        }
    }

    render() {
        const { t, categories, loading, pagination } = this.props;
        const { titleItemTable, modelItem, componentTable } = this.state;
        const dataSource = this.getTreeCategories(categories);
        return (
            <Wrapper className="mt-2 redeemtion-list">
                <ListComponent
                    tableKey="group-category-list"
                    classParent="m-0 p-0 col-md-12" classChildren="p-0"
                    marginTop={'0'} marginBottom={'0'}
                    loading={{ spinning: loading, size: 'large' }}
                    rowKey={(record, k) => record.id ? record.id : k}
                    dataSource={Func.getDataSource(dataSource || [], modelItem)}
                    columns={Func.columnsTable({
                        titleTable: titleItemTable,
                        component: componentTable,
                        itemName: 'groupCategory'
                    })}
                    pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, current: pagination.pageIndex, pageSize: pagination.pageSize }}
                    onChange={this.props.onTableChange}
                    componentTableList={{}}
                    expandedRowKeys={this.state.expendedRows}
                    onExpandedRowsChange={expendedRows => this.setState({ expendedRows })}
                />
            </Wrapper>
        );
    }

    renderEditComponent(item, index) {
        const { t, permissions, } = this.props;
        const removeItem = () => {
            return this.props.onDeleteGroupCategory && this.props.onDeleteGroupCategory(item)
        }
        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.groupCategory.title`)),
                content: item.name,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: removeItem,
            });
        };
        return (
            <Dropdown overlay={
                <Menu className="action-menu">
                    {
                        permissions && permissions.allowUpdate &&
                        <Menu.Item>
                            <Link to={Func.getPathWithParams(PATHS.GROUP_CATEGORY.DETAIL.path, { id: item.id })} className={`mr-2 colorPrimary`}>
                                <Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}
                            </Link>
                        </Menu.Item>
                    }

                    {
                        permissions && permissions.allowDelete &&
                        <Menu.Item onClick={onRemove}><Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</Menu.Item>
                    }
                </Menu>
            }>
                <Icon type="more" className="fs20 cursorPointer" />
            </Dropdown>
        )
    }

    getTreeCategories = (categories) => {
        return parseFlatArrayToTreeData(categories)
    }

}

GroupCategoryList.defaultProps = {
    categories: [],
    parents: [],
    pagination: {},
    permissions: {},
    loading: false,
    onTableChange: (pagination, filters, sorter) => { },
    onDeleteGroupCategory: (item) => { },
}

